import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { resendCode, verifyEmail } from '../../api/services/authService';
import AuthLayout from './AuthLayout';
import { AuthField } from './AuthField';

export default function VerifyEmail() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const email = state?.email || '';
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const [busy, setBusy] = useState(false);

  // The code was already emailed at sign-up, so arriving here (e.g. from a
  // blocked sign-in) does not send another one. A new code is only sent when
  // the user asks for it with "Resend code".

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setNotice('');
    if (!/^\d{6}$/.test(code.trim())) return setError('Enter the 6-digit code.');
    setBusy(true);
    try {
      await verifyEmail(email, code.trim());
      navigate('/login', { replace: true, state: { verified: true } });
    } catch (err) {
      setError(err.details?.fields?.code || err.message || 'Could not verify the code.');
    } finally {
      setBusy(false);
    }
  };

  const resend = async () => {
    setError('');
    setNotice('');
    try {
      await resendCode(email);
      setCode('');
      setNotice('A new code has been sent to your email. Use the newest one.');
    } catch (err) {
      setError(err.message);
    }
  };

  if (!email) {
    return (
      <AuthLayout title="Verify Your Email" subtitle="Start from sign up or sign in so we know which email to verify."
        footer={<><Link to="/signup">Create account</Link> · <Link to="/login">Sign in</Link></>} />
    );
  }

  return (
    <AuthLayout
      title="Verify Your Email"
      subtitle={<>Enter the 6-digit code we emailed to <strong>{email}</strong></>}
      footer={<Link to="/login">Back to sign in</Link>}
    >
      <form onSubmit={submit} noValidate>
        <AuthField label="Verification code" icon="bi-shield-check" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} placeholder="6-digit code" inputMode="numeric" autoComplete="one-time-code" />
        {notice && <div className="auth-success" role="status">{notice}</div>}
        {error && <div className="auth-error" role="alert">{error}</div>}
        <button className="auth-primary" type="submit" disabled={busy}>{busy ? 'Verifying…' : 'Verify Email'}</button>
        <button type="button" className="auth-link auth-link--center" onClick={resend}>Resend code</button>
      </form>
    </AuthLayout>
  );
}
